export const environment = {
  production: false,
  apiBaseUrl: '',
  auth: {
    useLocalDevAuth: false,
    clientId: '9a9867f7-5789-4b8b-95a5-94c30eec9498',
    authority: 'https://login.microsoftonline.com/08e689da-fe86-4337-923d-f46ec014f99d',
    redirectUri: 'https://portaldev.edison-datahub.com',
    apiScope: 'api://9a9867f7-5789-4b8b-95a5-94c30eec9498/access_as_user',
  },
};
